export default __webpack_public_path__ + "static/media/pantry1-afterI-768w.344ae3e8.png";